/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const tallCabinet24Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('TallCabinet24').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/higgins.glb',
            objectName: 'T2484',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=tall-cabinet-24.js.map